<!-- AI: This is the template for the new ClientEditDialogComponent -->
<h2 mat-dialog-title>Edit Client: {{ client.name }}</h2>

<mat-dialog-content>
  <form [formGroup]="clientForm" id="client-edit-form" (ngSubmit)="save()" *ngIf="countries$ | async as countries" novalidate>
    <div class.="form-grid">
      <mat-form-field>
        <input matInput placeholder="Name" formControlName="name" appAutofocus />
      </mat-form-field>

      <mat-form-field>
        <input matInput placeholder="BusinessId" formControlName="business_id" />
      </mat-form-field>

      <app-company-form-fields [formGroup]="clientForm" [entity]="client" [editMode]="true"></app-company-form-fields>

      <mat-form-field>
        <mat-select placeholder="Country" formControlName="country">
          <mat-option *ngFor="let option of countries.all()" [value]="option.code">
            {{option.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <div class="toggle-checkbox">
        <mat-checkbox class="full-width" formControlName="mark_prepayment_register_checked" labelPosition="after">Update Prepayment Register Status</mat-checkbox>
      </div>

      <div class="toggle-checkbox">
        <mat-checkbox class="full-width" formControlName="is_in_prepayment_register" labelPosition="after">In Prepayment Register</mat-checkbox>
      </div>

      <div>
        <mat-form-field *ngIf="!selectingLeadSource" (click)="selectLeadSource()">
          <input matInput type="text" placeholder="Lead Source" [value]="selectedLeadSource?.name" readonly="true" />
        </mat-form-field>
        <app-lead-source-auto-complete *ngIf="selectingLeadSource" clearable field="name" (selected)="leadSourceSelected($event)" (cleared)="leadSourceCleared()">
        </app-lead-source-auto-complete>
      </div>

      <div>
        <mat-form-field *ngIf="!selectingResponsibleSeller" (click)="selectResponsibleSeller()">
          <input matInput type="text" placeholder="Responsible Seller" [value]="selectedResponsibleSeller?.name" readonly="true" />
        </mat-form-field>
        <app-partner-auto-complete *ngIf="selectingResponsibleSeller" clearable field="name" (selected)="responsibleSellerSelected($event)" (cleared)="responsibleSellerCleared()">
        </app-partner-auto-complete>
      </div>

      <div class="toggle-checkbox">
        <mat-checkbox class="full-width" formControlName="has_credit_limit" labelPosition="after">Credit Limit</mat-checkbox>
      </div>

      <mat-form-field *ngIf="clientForm.value.has_credit_limit" formGroupName="credit_limit">
        <ng-container formGroupName="limit">
          <input matInput placeholder="Credit Limit" formControlName="amount" type="number" />
        </ng-container>
      </mat-form-field>

      <div class="toggle-checkbox">
        <mat-checkbox class="full-width" formControlName="has_aaa_rating" labelPosition="after">Credit Rating</mat-checkbox>
      </div>

      <mat-form-field *ngIf="clientForm.value.has_aaa_rating" formGroupName="aaa_rating">
        <mat-select placeholder="Rating" formControlName="category">
          <mat-option *ngFor="let rating of aaaRatings" [value]="rating">
            {{rating}}
          </mat-option>
        </mat-select>
      </mat-form-field>

    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Cancel</button>
  <button mat-button color="primary" type="submit" form="client-edit-form" [disabled]="!clientForm.valid">Save</button>
</mat-dialog-actions>
